module.exports = __webpack_public_path__ + "img/empty-wishlist.aefc28dc.png";